"use strict";

var _regeneratorRuntime = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeQueryPagination = exports.apiRequest = exports.recoverPasswordRequest = exports.googleLoginRequest = exports.loginRequest = exports.resetAxiosToken = exports.setAxiosToken = exports.setApiBaseUrl = exports.axiosInstance = void 0;

var axios_1 = require("axios");

var settings_1 = require("./settings");

exports.axiosInstance = axios_1.default.create();

var setApiBaseUrl = function setApiBaseUrl(baseURL) {
  exports.axiosInstance.defaults.baseURL = baseURL;
};

exports.setApiBaseUrl = setApiBaseUrl;

var setAxiosToken = function setAxiosToken(token) {
  exports.axiosInstance.defaults.headers.common['Authorization'] = "Bearer ".concat(token);
};

exports.setAxiosToken = setAxiosToken;

var resetAxiosToken = function resetAxiosToken() {
  delete exports.axiosInstance.defaults.headers.common['Authorization'];
};

exports.resetAxiosToken = resetAxiosToken;
var mockInstance = axios_1.default.create({
  baseURL: settings_1.default.mockApi.baseUrl
});

var loginRequest = function loginRequest(email, password, source) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return exports.axiosInstance.post('/account/login', {
              email: email,
              password: password,
              source: source
            });

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.loginRequest = loginRequest;

var googleLoginRequest = function googleLoginRequest(email, password) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return exports.axiosInstance.post('/account/google/login', {
              email: email,
              password: password
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.googleLoginRequest = googleLoginRequest;

var recoverPasswordRequest = function recoverPasswordRequest(email) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve) {
              setTimeout(resolve, 1000);
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

exports.recoverPasswordRequest = recoverPasswordRequest;

var apiRequest = function apiRequest(method, url, payload, params, mock) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!mock) {
              _context4.next = 6;
              break;
            }

            _context4.next = 3;
            return mockInstance.request(Object.assign(Object.assign({
              method: method,
              url: url
            }, {
              data: payload
            }), {
              params: params
            }));

          case 3:
            _context4.t0 = _context4.sent;
            _context4.next = 9;
            break;

          case 6:
            _context4.next = 8;
            return exports.axiosInstance.request(Object.assign(Object.assign({
              method: method,
              url: url
            }, {
              data: payload
            }), {
              params: params
            }));

          case 8:
            _context4.t0 = _context4.sent;

          case 9:
            response = _context4.t0;
            return _context4.abrupt("return", response.data);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};

exports.apiRequest = apiRequest;

var makeQueryPagination = function makeQueryPagination() {
  var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var queryParams = Object.assign({}, request);
  var filters = request && request.filters || {};
  Object.keys(filters).map(function (filter) {
    if (typeof filters[filter] === 'boolean') {
      queryParams[filter] = filters[filter];
    }

    if (Array.isArray(filters[filter])) {
      var arrayFilter = filters[filter];

      if (arrayFilter.length > 0) {
        queryParams[filter] = arrayFilter.join(',');
      }
    }
  });
  delete queryParams.filters;
  return queryParams;
};

exports.makeQueryPagination = makeQueryPagination;